<template>
  <div class="page-header-chat"><a :href="chatUrl" @click.prevent="listeners.chat">Chat</a></div>
</template>
<script>
export default {
  props: ['chatUrl'],
};
</script>
<style></style>
